// src/components/charts/BreakEvenChart.jsx
import React, { useState, useEffect } from 'react';
import { Card, Alert, Spinner } from 'react-bootstrap';
import BarChart from '../agComponents/BarChart';
import kpiService from '../../services/kpiService';

/**
 * Componente que muestra el gráfico de visitantes para break even
 * Barras apiladas con datos dinámicos
 */
const BreakEvenChart = ({ fechaInicio, fechaFin, localId }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await kpiService.getVisitantesBreakEven({
          fechaInicio,
          fechaFin,
          localId,
        });

        if (response.success && response.data) {
          setChartData(response.data);
        } else {
          throw new Error('No se pudieron cargar los datos');
        }
      } catch (err) {
        console.error('Error fetching break even data:', err);
        setError('Error al cargar el gráfico. Por favor, intenta nuevamente.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fechaInicio, fechaFin, localId]);

  if (error) {
    return (
      <Card>
        <Card.Body>
          <Alert variant="danger">{error}</Alert>
        </Card.Body>
      </Card>
    );
  }

  if (loading) {
    return (
      <Card>
        <Card.Body className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Cargando datos...</p>
        </Card.Body>
      </Card>
    );
  }

  // Validación adicional de datos
  if (!chartData || !Array.isArray(chartData.data) || chartData.data.length === 0) {
    return (
      <Card>
        <Card.Body>
          <h5 className="mb-3">Visitantes para break even</h5>
          <p className="text-muted text-center py-4">No hay datos disponibles</p>
        </Card.Body>
      </Card>
    );
  }

  // Calcular totales de forma segura
  const totalMedio = chartData.data.reduce((acc, d) => acc + (d.medio || 0), 0);
  const totalBreakEven = chartData.data.reduce((acc, d) => acc + (d.breakEven || 0), 0);

  return (
    <Card>
      <Card.Body>
        <h5 className="mb-3">Visitantes para break even</h5>
        
        <BarChart
          data={chartData.data}
          xKey="day"
          series={chartData.series || []}
          stacked={true}
          height={350}
        />

        {/* Estadísticas adicionales */}
        <div className="mt-3 pt-3 border-top">
          <div className="row text-center">
            <div className="col-6">
              <div className="text-muted small">Total medio visitantes</div>
              <div className="h5 mb-0">
                {totalMedio.toLocaleString('es-ES')}
              </div>
            </div>
            <div className="col-6">
              <div className="text-muted small">Total break-even</div>
              <div className="h5 mb-0">
                {totalBreakEven.toLocaleString('es-ES')}
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default BreakEvenChart;